module.exports = "/_next/static/images/kitten-swap-e85852c9de1262235b62a27c230af655.svg";